<template>
    <div id="errorPageContainer">
        <div class="errorCode">TODO: Error Seite für Mandy anpassen</div>
        <div class="oops">Oops!</div>
        <div class="errorCode">404 - Seite nicht gefunden</div>
        <div class="errorText">Die angeforderte URL wurde auf dem Server nicht gefunden.</div>
    </div>
</template>

<script>
    export default {
        name: "Error404"
    }
</script>

<style scoped>
    #errorPageContainer{
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        height: 57vh;
        width: 100%;
    }

    .oops{
        font-size: 12em;
        font-weight: bolder;
        animation:flow 15s ease-in-out infinite;
        background:linear-gradient(90deg, #da2567, #b92972, #752b77, #03b3ea);
        background-size: 300%;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 1rem;
    }

    .errorCode{
        font-size: 1.8rem;
        margin-bottom: 1rem;
        font-weight: 500;
    }

    .errorText{
        font-size: 1.3rem;

        font-weight: 500;
    }

    @keyframes flow {
        0% {
            background-position: 0 50%;
        }

        50%{
            background-position: 100% 50%;
        }

        100%{
            background-position: 0 50%;
        }
    }
</style>